import { inject, Injectable, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// 注意不要移除 root, 因為 mode 要記錄在記憶體, 除非之後要換機制.
@Injectable({
  providedIn: 'root',
})
export class ModeSelectorModel {
  readonly model = 'model';
  readonly route = inject(ActivatedRoute);
  // true 代表穿搭, 使用 listAspectRatio
  // false 代表顏色展開, 使用 clothAspectRatio.
  // undefined 代表在建構子, 尚未處理 route query param 之前.
  readonly mode = signal<boolean | undefined>(undefined);

  constructor() {
    this.updateMode();
  }

  setListMode(): void {
    this.mode.set(true);
  }

  setClothMode(): void {
    this.mode.set(false);
  }

  updateMode(): void {
    const routeMode = this.route.snapshot.queryParams['mode'];
    if (routeMode) {
      // 有 route 參數, 就以參數為主.
      this.mode.set(routeMode === this.model);
    } else if (this.mode() === undefined) {
      // 沒 route 參數, 且 mode 還是 undefined, 就給預設穿搭顯示
      this.mode.set(true);
    }
    // else 含義：當沒有 route 參數, 且 mode 非 undefined, 就是維持當下的 mode.
  }
}
